import React from 'react';
export const ConfigContext = /*#__PURE__*/React.createContext({
  baseUrl: '..',
  apiVersion: 32
});